import './polyfills/nodeListForEach';
import './helpers/globals';
import ShopifySectionsManager from '@pixelunion/shopify-sections-manager';
import 'intersection-observer';
import rimg from '@pixelunion/rimg-shopify';
import PxsMap from '@pixelunion/pxs-map';
import './helpers/polyfill-nodelist-foreach';
// Flickity iOS fix
import flickityTouchFix from './helpers/FlickityTouchFix';
// Templates
import TemplateAccount from './templates/TemplateAccount';
import TemplateLogin from './templates/TemplateLogin';
import TemplateGiftCard from './templates/TemplateGiftCard';
// Components
import RTE from './components/RTE';
import Select from './components/Select';
// Dynamic Sections
import DynamicBlog from './sections/DynamicBlog';
import DynamicCollectionsList from './sections/DynamicCollectionsList';
import DynamicFeaturedCollection from './sections/DynamicFeaturedCollection';
import DynamicMasonry from './sections/DynamicMasonry';
import DynamicPromotion from './sections/DynamicPromotion';
import DynamicSlideshow from './sections/DynamicSlideshow';
import DynamicTestimonials from './sections/DynamicTestimonials';
import DynamicVideoWithTextOverlay from './sections/DynamicVideoWithTextOverlay';
// Static sections
import StaticArticle from './sections/StaticArticle';
import StaticHeader from './sections/StaticHeader';
import StaticFooter from './sections/StaticFooter';
import StaticCollection from './sections/StaticCollection';
import StaticCart from './sections/StaticCart';
import StaticBlog from './sections/StaticBlog';
import StaticBlogMasonry from './sections/StaticBlogMasonry';
import StaticCollectionsList from './sections/StaticCollectionsList';
import StaticProductRecommendations from './sections/StaticProductRecommendations';
import ProductSection from './sections/ProductSection';

function spamCheck(e) {
  if (e.target.querySelector('.comment-check').value.length > 0) {
    e.preventDefault();
  }
}

rimg.init();

const sections = new ShopifySectionsManager();
// Dynamic Sections
sections.register('dynamic-blog', section => new DynamicBlog(section));
sections.register('dynamic-collections-list', section => new DynamicCollectionsList(section));
sections.register('dynamic-featured-collection', section => new DynamicFeaturedCollection(section));
sections.register('dynamic-masonry', section => new DynamicMasonry(section));
sections.register('dynamic-promotion', section => new DynamicPromotion(section));
sections.register('dynamic-slideshow', section => new DynamicSlideshow(section));
sections.register('dynamic-testimonials', section => new DynamicTestimonials(section));
sections.register('dynamic-video-with-text-overlay', section => new DynamicVideoWithTextOverlay(section));
sections.register('product', section => new ProductSection(section));
sections.register('pxs-map', section => new PxsMap(section));
// Static Sections
sections.register('static-article', section => new StaticArticle(section));
sections.register('static-collection', section => new StaticCollection(section));
sections.register('static-collections-list', section => new StaticCollectionsList(section));
sections.register('static-header', section => new StaticHeader(section));
sections.register('static-footer', section => new StaticFooter(section));
sections.register('static-cart', section => new StaticCart(section));
sections.register('static-blog', section => new StaticBlog(section));
sections.register('static-blog-masonry', section => new StaticBlogMasonry(section));
sections.register('static-product-recommendations', section => new StaticProductRecommendations(section));

flickityTouchFix();

const contactForm = document.querySelector('.contact-form');

if (contactForm) {
  contactForm.addEventListener('submit', event => spamCheck(event));
}

document.addEventListener('DOMContentLoaded', () => document.documentElement.classList.remove('loading'));

// Set up conditionals
const isProduct = document.body.classList.contains('template-product');
const isAccount = document.body.getAttribute('class').indexOf('-customers-') > 0;
const isPasswordPage = document.body.classList.contains('template-password');
const isGiftCardPage = document.body.classList.contains('template-gift_card');

if (isAccount) { new TemplateAccount({ el: document.body }); }
if (isPasswordPage) { new TemplateLogin(); }
if (isGiftCardPage) { new TemplateGiftCard(); }

if (!isProduct) {
  document.querySelectorAll('.rte').forEach(rte => new RTE({ el: rte }));
  document.querySelectorAll('select').forEach(sel => new Select({ el: sel }));
}
